import { Question } from '@phosphor-icons/react';

export default Question;
